import NavBar from "./components/NavBar";
import '../styles/Common.css';

export default function HomePage() {
    const RELEASE_YEAR = 2025;

    return(
        <>
            <NavBar/>

            <div className={'container mt-2'}>
                {/* Logo and name */}
                <div className="text-center mt-3">
                    <img src='/favicon.ico' alt="Logo" width="195"/>
                </div>

                <h1>URM & TM Simulator</h1>

                {/* Main features */}
                <div className="container mt-5 mb-3 p-2 d-flex flex-column main-features-container">
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <h3>Interactive step-by-step execution</h3>
                            <p>Execute your URM program or TM step-by-step with opportunity to go step back</p>
                        </div>
                        <div className="col-md-4">
                            <h3>Easily save your URM program or TM</h3>
                            <p>to continue working on it later, or to share it, with import/export feature</p>
                        </div>
                        <div className="col-md-4">
                            <h3>Export calculations</h3>
                            <p>to share it with lecturer or classmates</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <h3>User-friendly editors</h3>
                            <p>with errors and inconsistencies detection</p>
                        </div>
                        <div className="col-md-4">
                            <h3>Calculate the final result</h3>
                            <p>of the URM or TM</p>
                        </div>
                        <div className="col-md-4">
                            <h3>A fuse in case of infinite calculations</h3>
                            <p>set limit of steps to avoid infinite calculations</p>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mb-3 text-center">
                    &copy;
                    {
                        (new Date().getFullYear() === RELEASE_YEAR)
                        ? RELEASE_YEAR
                        : `${RELEASE_YEAR}-${new Date().getFullYear()}`
                    } Yaroslav Drovolskyi

                    <p className={'m-0'}>Developed as a coursework</p>
                    <p className={'m-0'}>If you have any suggestions or feedback,
                        feel free to contact me at <a href="mailto:yar.drovolsky@gmail.com">
                            yar.drovolsky@gmail.com
                    </a></p>
                </div>
            </div>
        </>

    )
        ;
}